import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../lib/theme";
import { policySlug } from "../lib/api";
import { Cookie, X } from "@phosphor-icons/react";

/**
 * Slim cookie-consent banner. Persists the choice to localStorage so it only
 * shows once. Links straight to the Cookie Policy document when one has been
 * uploaded via the admin.
 */
export default function CookieConsent() {
  const { settings } = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("ww_cookie_consent")) setVisible(true);
    } catch { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem("ww_cookie_consent", "accepted"); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  const cookieDoc = (Array.isArray(settings?.policy_documents) ? settings.policy_documents : [])
    .find((d) => d && d.url && /cookie/i.test(d.name || ""));

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 left-0 right-0 z-[55] md:pl-20"
    >
      <div className="ww-glass border-t border-[#2A2A2A] px-5 md:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <Cookie size={20} color="#DFFF00" weight="duotone" className="shrink-0" />
        <p className="flex-1 text-sm" style={{ color: "var(--ww-text)" }}>
          We use minimal, privacy-respecting cookies to keep the site working and understand traffic.
          {cookieDoc ? (
            <>
              {" "}Read our{" "}
              <Link
                to={`/legal/${policySlug(cookieDoc.name)}`}
                className="text-[#DFFF00] hover:underline"
                data-testid="cookie-consent-policy-link"
              >
                Cookie Policy
              </Link>.
            </>
          ) : null}
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={accept}
            data-testid="cookie-consent-accept"
            className="btn-primary text-[11px] py-2 px-4"
          >
            Got it
          </button>
          <button
            onClick={accept}
            aria-label="Dismiss"
            className="text-[#8E8E93] hover:text-white p-1"
            data-testid="cookie-consent-dismiss"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
